import { useNavigate } from 'react-router-dom';
import { PostCreator } from '@/components/PostCreator';
import headerBgMobile from '@/assets/header-bg-mobile.jpg';

export default function ComposePage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen relative">
      {/* Fixed Background Image */}
      <div 
        className="fixed inset-0 bg-cover bg-center bg-no-repeat z-0"
        style={{
          backgroundImage: `url(${headerBgMobile})`
        }}
      />
      
      {/* Content with backdrop */}
      <div className="relative z-10 w-full mx-auto max-w-2xl bg-white/5 backdrop-blur-sm shadow-xl min-h-screen pb-20">
        <PostCreator onBack={() => navigate('/')} />
      </div>
    </div>
  );
}
